module.exports = __webpack_public_path__ + "img/mobileLogo.6fdba93f.svg";